import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/kodiaq/comfort",
  "description": "Совершенная ходовая часть автомобиля, мощный кузов и салон с великолепной звукоизоляцией обеспечивают водителю и пассажирам обновленного ŠKODA KODIAQ 2023 первоклассный комфорт. Подробный обзор автомобиля, фото, технические характеристики, комплектации  на официальном сайте ŠKODA в России.",
  "huggerTemplate": "default",
  "keywords": "Skoda Kodiaq Comfort",
  "name": "kodiaq-comfort",
  "title": "Комфорт обновленного ŠKODA KODIAQ 2023/2022 | Богатое оснащение и вместительный багажник Шкода Кодиак - официальный сайт ŠKODA в России"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageSubHeading = makeShortcode("SimpleMainStageSubHeading");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const QueriedGallery = makeShortcode("QueriedGallery");
const ShowRoomTextBlock = makeShortcode("ShowRoomTextBlock");
const ShowRoomTextBlockTitle = makeShortcode("ShowRoomTextBlockTitle");
const ShowRoomTextBlockText = makeShortcode("ShowRoomTextBlockText");
const Slider = makeShortcode("Slider");
const SlideIcon = makeShortcode("SlideIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="center" horizontalAlign="left" src="/m/kodiaq-2021-comfort-banner.jpg" mobileSrc="/m/kodiaq-2021-comfort-banner-mob.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageSubHeading mdxType="SimpleMainStageSubHeading">КОМФОРТ</SimpleMainStageSubHeading>
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">ПО ВАШИМ ЗАЯВКАМ</SimpleMainStageHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> ŠKODA KODIAQ очень адаптивен </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Например, сиденья второго ряда что в 5‑местном автомобиле, что в 7‑местном
    двигаются взад-вперёд на 18 см — для быстрого перераспределения места в
    салоне и багажнике. Количество же электронных настроек функций комфорта так
    сразу и не счесть.
  </DefaultSectionText>
  <FeaturesSliderQueried tags="kodiaq-fl-comfort-slider-one" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <DefaultPaddedSection mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Решения Simply Clever</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    {" "}
    «Просто гениально», — не только рекламный слоган, но и часть философии марки
    ŠKODA. Эти слова находят отражение в ряде продуманных решений, делающих повседневное
    использование автомобиля более лёгким и комфортным. Удовольствие от владения
    машиной складывается из мелочей.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="6" type="modal" tags="kodiaq-fl-2021-comfortpage" mdxType="QueriedGallery" />
    <DefaultPaddedSection noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> В НУЖНОЙ ПОСЛЕДОВАТЕЛЬНОСТИ </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Семейный автомобиль — второй дом, а потому вопросам его охраны уделено
    особое внимание. Для ŠKODA KODIAQ предлагается сигнализация с автономной
    сиреной, реагирующая на проникновение в салон / под капот, внезапное падение
    напряжения в бортовой сети, буксировку автомобиля. Устройство, установленное
    непосредственно на заводе, гарантирует высокую степень защиты при отсутствии
    необходимости носить с собой дополнительные пульты. Порядок отпирания дверей
    настраивается. Можно сделать так, чтобы центральный замок сначала открывал
    одну лишь водительскую дверь или две двери с одного борта машины. Когда в
    машину обычно садится сразу вся семья, логично, чтобы в один момент
    отпирались все двери — и такая настройка есть. Автоматическое закрывание
    дверей с началом движения вряд ли кого‑то будет раздражать, но и эту функцию
    можно отключить.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <ShowRoomTextBlock desktopPic="/m/kodiaq-2021-comfort-banner2.jpg" mobilePic="/m/kodiaq-2021-comfort-banner2-mob.jpg" model="kodiaq" mdxType="ShowRoomTextBlock">
  <ShowRoomTextBlockTitle mdxType="ShowRoomTextBlockTitle"> ДОБРО ПОЖАЛОВАТЬ! </ShowRoomTextBlockTitle>
  <ShowRoomTextBlockText main key="main" mdxType="ShowRoomTextBlockText">
    Логотип ŠKODA, проецируемый на землю при открытых передних дверях, —
    приятное дополнение к пакету светодиодной эстетической подсветки салона,
    положенное обновлённому ŠKODA KODIAQ. В нижней части двери —
    светоотражатель, предупреждающий других участников движения об опасности. На
    пороге — декоративная накладка: это и украшение, и защита лакокрасочного
    покрытия.
  </ShowRoomTextBlockText>
    </ShowRoomTextBlock>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> БАГАЖНИК КАК АРГУМЕНТ </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    «Очень большой, правильной формы, с возможностью трансформации». Обычно так
    описывают багажное отделение ŠKODA KODIAQ. Всё верно. Остаётся добавить, что
    багажник автомобиля ещё и образцово организован: получится быстро и надёжно
    закрепить грузы самых разных форм, масс и размеров.
  </DefaultSectionText>
  <FeaturesSliderQueried tags="kodiaq-fl-comfort-slider-two" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPt mdxType="DefaultPaddedSection">
  <Slider slidesToShow={1} mdxType="Slider">
    <SlideIcon key="/m/subscribe.svg" icon="/m/subscribe.svg" title="Подписаться" text=" Подпишитесь на новости о ŠKODA" buttonText="Подписаться на новости" buttonLink="/subscribe" mdxType="SlideIcon" />
  </Slider>
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      